const consoleLog = {
  heading: 'Du bist am Quellcode interessiert?',
  text: 'Den kompletten Code findest Du auf meinem Github-Profil.',
  link: 'https://github.com/peter-stuhlmann/Photography-Portfolio',
};

export default consoleLog;
